/* GriffinResponsiveAside.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhkhfxm%7Bbackground-color%3Avar(--ds-surface-sunken%2C%23f8f8f8)%7D");
import React, { PropsWithChildren, useState } from 'react';
import Box from '@atlaskit/primitives/box';
import { media } from '@atlaskit/primitives/responsive/media';
// eslint-disable-next-line @townsquare/rules/no-xcss
import { xcss } from '@atlaskit/primitives/xcss';
import { GriffinMainGridAside, type defaultAsideWidths } from '@townsquare/griffin-main-grid/aside';
import { useOnMount } from '@townsquare/hooks';
import { ErrorBoundary } from '@townsquare/monitoring/error-boundary';
type Props = {
  hasNewHeader: boolean;
};
const compiledStyles = {
  aside: "_bfhkhfxm"
};
const asideStyles = xcss({
  height: '100%',
  paddingBlockStart: 'space.300',
  paddingInlineStart: 'space.300',
  paddingInlineEnd: 'space.300',
  // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
  [media.above.lg]: {
    paddingBlockStart: 'space.400',
    paddingInlineStart: 'space.400',
    paddingInlineEnd: 'space.400'
  }
});
const asideWithBorderStyles = xcss({
  borderInlineStart: `1px solid ${"var(--ds-border, #0B120E24)"}`
});

// Based on https://atlassian.design/foundations/grid-beta#side-navigation-and-aside
const getAsideWidth = (bodyWidth: number) => {
  if (bodyWidth < 1440) {
    return 320; // defaultSmall
  } else if (bodyWidth < 1768) {
    return 400; // default
  } else {
    return 504; // defaultLarge
  }
};
export const GriffinResponsiveAside = ({
  children,
  hasNewHeader
}: PropsWithChildren<Props>): React.JSX.Element => {
  const [asideWidth, setAsideWidth] = useState<defaultAsideWidths>();
  useOnMount(() => {
    const resizeObserver = new ResizeObserver(([entry]: ResizeObserverEntry[]) => {
      const {
        width
      } = entry.contentRect;
      setAsideWidth(getAsideWidth(width));
    });
    resizeObserver.observe(window.document.body);
    return () => {
      resizeObserver.unobserve(window.document.body);
    };
  });
  return <ErrorBoundary variant="aside">
			<GriffinMainGridAside defaultWidth={asideWidth} xcss={!hasNewHeader && compiledStyles.aside}>
				<Box xcss={[asideStyles, hasNewHeader && asideWithBorderStyles]}>{children}</Box>
			</GriffinMainGridAside>
		</ErrorBoundary>;
};